module.exports = __webpack_public_path__ + "img/1728541938965-WhatsApp Image 2024-10-10 at 14.31.19.jpeg.493fa2fb.webp";